import { colors } from 'spw-theme';
import styled from 'styled-components';
import { Box } from '@mui/material';
import { Link } from 'react-router-dom-v5';

export const UnstyledLink = styled.a`
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  display: flex;
  align-item: center;
`;

export const UnstyledReactLink = styled(Link)`
  text-decoration: none;
  color: inherit;
`;

export const SPWLinkNoRedirect = styled(Box)`
  && {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: ${colors.mainBlue};
    cursor: pointer;
    display: flex;
    align-item: center;
    text-transform: uppercase;
  }
`;
